import { Component } from '@angular/core';
import { ApiRequestDto, ReportsService } from "../../api";
import { FacilitiesService } from "../../core";
import { DownloadFileContentModal } from '../download-file-content/download-file-content-modal.component';
import { ErrorObjectTypeEnum, LoadingError } from '../../core/error-catching.service';
import { catchError } from 'rxjs/operators';

@Component({
    selector: 'my-resident-diagnosis-modal',
    styleUrls: ['../download-file-content/download-file-content-modal.component.scss'],
    templateUrl: '../download-file-content/download-file-content-modal.component.html'
})
export class ResidentDiagnosisModal extends DownloadFileContentModal {

    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
    }

    reportName: string = "Resident Diagnosis";
    title: string = "Download Resident Diagnosis";
    promptText: string = "Download the Resident Diagnosis report?";

    generateContent() {
        this.hideSpinner = false;

        const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList,
        };
        this.reportService.reportsGetGeneratedResidentDiagnosisReport(requestParams)
            .pipe(catchError((error) => {
                this.hideSpinner = true;
                throw new LoadingError(this.reportName, ErrorObjectTypeEnum.Report);
            }))
            .subscribe((result: Blob) => {
                    this.downloadFile(result, 'Resident Diagnosis.xls');
                    this.closeModal();
            });
    }
}